/// <amd-module name="Feed/Legacy/Protocols/Common/PermanentDeleteCommandHelper" />
import * as Utils_String from "VSS/Core/Util/String";

import { PackageCommandIds } from "Feed/Common/Constants/Constants";
import { Package, PackageVersion } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { IGeneralDialogProps } from "Feed/Common/Types/IGeneralDialogProps";
import * as Actions from "Feed/Legacy/Actions/Actions";
import { RecycleBinActions } from "Feed/Legacy/Actions/RecycleBinActions";
import { PermanentDeletePackagesCommand } from "Feed/Legacy/Protocols/Common/PackageCommands";
import { IPackageCommand } from "Feed/Legacy/Types/IPackageCommand";

export class PermanentDeleteCommandHelper {
    public static getCommands(
        protocolType: string,
        selectedPackages?: Package[],
        selectedVersions?: PackageVersion[],
        packageName?: string
    ): IPackageCommand[] {
        const packageCommands = new Array<IPackageCommand>();
        if (selectedVersions && selectedVersions.length > 0) {
            const headerText =
                selectedVersions.length === 1
                    ? Utils_String.format(
                          PackageResources.PermanentDeleteDialog_HeaderText_PackageVersion,
                          packageName,
                          selectedVersions[0].version
                      )
                    : Utils_String.format(
                          PackageResources.PermanentDeleteDialog_HeaderText_BatchPackageVersion,
                          selectedVersions.length.toString(),
                          packageName
                      );
            const commandName = PackageResources.PackageCommands_PermanentDeletePackage;
            const confirmText =
                selectedVersions.length === 1
                    ? Utils_String.format(
                          PackageResources.PermanentDeleteDialog_ConfirmText_OneVersion,
                          packageName,
                          selectedVersions[0].version
                      )
                    : PackageResources.PermanentDeleteDialog_ConfirmText_MultipleVersion;
            const deleteDialogProps: IGeneralDialogProps = this.getPermanentDeleteDialogProps(
                headerText,
                confirmText,
                protocolType,
                null,
                selectedVersions
            );
            packageCommands.push(
                new PermanentDeletePackagesCommand(PackageCommandIds.PermanentDelete, commandName, deleteDialogProps)
            );
        }

        return packageCommands;
    }

    public static getPermanentDeleteDialogProps(
        headerText: string,
        confirmText: string,
        protocolType: string,
        selectedPackages?: Package[],
        selectedVersions?: PackageVersion[]
    ): IGeneralDialogProps {
        const dialogProps: IGeneralDialogProps = {
            headerText,
            confirmText,
            saveButtonClassName: "delete-button",
            dialogClassName: "delete-dialog",
            saveButtonText: PackageResources.PermanentDeletionDialogContent_OkButton,
            onSavePrimaryButtonText: PackageResources.PackageCommands_DeletePackage_Deleting,
            onSaveCallback: () =>
                RecycleBinActions.PackagesPermanentDeleted.invoke({
                    selectedPackages,
                    selectedVersions
                }),
            onDismissCallback: () => Actions.DialogOpenChanged.invoke(null)
        };

        return dialogProps;
    }
}
